export var ROW;
(function (ROW) {
    ROW["PARENT"] = "sds-table__row--parent";
    ROW["CHILD"] = "sds-table__row--child";
    ROW["IDENTIFIER"] = "id";
    ROW["AGGREGATED_TYPE"] = "aggregatedType";
    ROW["LEVEL"] = "level";
    ROW["PATH"] = "path";
    ROW["HAS_LOAD_MORE"] = "hasLoadMore";
    ROW["LOAD_MORE"] = "loadMore";
    ROW["NO_RESULTS"] = "noResults";
    ROW["LAZY"] = "lazy";
    ROW["CHILDREN"] = "children";
    ROW["CHILDREN_COUNT"] = "childrenCount";
    ROW["HIDDEN"] = "hidden";
    ROW["EXPANDED"] = "expanded";
    ROW["SUM_CLASS"] = "sds-table__row-sum";
})(ROW || (ROW = {}));
export var CONTROL;
(function (CONTROL) {
    CONTROL["CLASS"] = "sds-table__control";
    CONTROL["EXPAND"] = "sds-table__control--expand";
    CONTROL["COLLAPSE"] = "sds-table__control--collapse";
    CONTROL["PATH"] = "sds-table__path";
})(CONTROL || (CONTROL = {}));
export var CONTROL_MARKUP;
(function (CONTROL_MARKUP) {
    CONTROL_MARKUP["SUM"] = "<sds-icon size=\"16\" name=\"sum\"></sds-icon>";
    CONTROL_MARKUP["CHILD"] = "<sds-icon size=\"16\" name=\"radio_button\"></sds-icon>";
    CONTROL_MARKUP["CHILD_TAG"] = "sds-icon";
    CONTROL_MARKUP["EXPAND"] = "<sds-button-icon type=\"secondary\" size=\"xs\" icon=\"plus\"></sds-button-icon>";
    CONTROL_MARKUP["COLLAPSE"] = "<sds-button-icon type=\"secondary\" size=\"xs\" icon=\"minus\"></sds-button-icon>";
    CONTROL_MARKUP["PARENT_TAG"] = "sds-button-icon";
    CONTROL_MARKUP["LOAD_MORE"] = "<sds-button label=\"Load More\" size=\"md\" type=\"link\" icon=\"refresh\"></sds-button>";
})(CONTROL_MARKUP || (CONTROL_MARKUP = {}));
